import { IconProps } from '../types';

const UpArrowSmall = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M14.8671 12.8788C15.4706 12.2137 16.5159 12.2137 17.1193 12.8788L20.9292 17.0781C21.8157 18.0552 21.1224 19.6203 19.8031 19.6203H12.1834C10.8641 19.6203 10.1708 18.0552 11.0573 17.0781L14.8671 12.8788Z" />
  </svg>
);

export default UpArrowSmall;
